import * as _clsx2 from "clsx";
var _clsx = _clsx2;
try {
  if ("default" in _clsx2) _clsx = _clsx2.default;
} catch (e) {}
import * as _preact2 from "preact";
var _preact = _preact2;
try {
  if ("default" in _preact2) _preact = _preact2.default;
} catch (e) {}
import _cssReset from "../../../../../lib/cssReset";
import _Snackbar from "../Snackbar";
import _RedirectDialogCss from "./RedirectDialog-css";
var exports = {};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedirectDialog = void 0;
const clsx_1 = __importDefault(_clsx);
const preact_1 = _preact;
const cssReset_1 = _cssReset;
const Snackbar_1 = _Snackbar;
const RedirectDialog_css_1 = __importDefault(_RedirectDialogCss);
class RedirectDialog {
  constructor() {
    this.root = null;
  }
  attach() {
    const el = document.documentElement;
    this.root = document.createElement("div");
    this.root.className = "-cbwsdk-css-reset";
    el.appendChild(this.root);
    (0, cssReset_1.injectCssReset)();
  }
  present(props) {
    this.render(props);
  }
  clear() {
    this.render(null);
  }
  render(props) {
    if (!this.root) return;
    (0, preact_1.render)(null, this.root);
    if (!props) return;
    (0, preact_1.render)((0, preact_1.h)(RedirectDialogContent, Object.assign({}, props, {
      onDismiss: () => {
        this.clear();
      }
    })), this.root);
  }
}
exports.RedirectDialog = RedirectDialog;
const RedirectDialogContent = ({
  title,
  buttonText,
  darkMode,
  onButtonClick,
  onDismiss
}) => {
  const theme = darkMode ? "dark" : "light";
  return (0, preact_1.h)(Snackbar_1.SnackbarContainer, {
    darkMode: darkMode
  }, (0, preact_1.h)("div", {
    class: "-cbwsdk-redirect-dialog"
  }, (0, preact_1.h)("style", null, RedirectDialog_css_1.default), (0, preact_1.h)("div", {
    class: "-cbwsdk-redirect-dialog-backdrop",
    onClick: onDismiss
  }), (0, preact_1.h)("div", {
    class: (0, clsx_1.default)("-cbwsdk-redirect-dialog-box", theme)
  }, (0, preact_1.h)("p", null, title), (0, preact_1.h)("button", {
    onClick: onButtonClick
  }, buttonText))));
};
export default exports;